import {
    projectsAndGroupsMixSelector,
    projectsForSummerySelector,
    environmentTypeSelector,
    timePeriodSelector,
    summaryProjectOrGroupSelector,
    summaryGridSizeSelector,
    summarySelector,
    summaryLoadingSelector,
    //viewInfoSelector,
    summarySettingsSelector,
    timePeriodInfoSelector
} from './../../../selectors/summary';
import { settingsSelector, editModeSelector } from '../../../selectors/settings';
import { environmentTypesSelectorWithoutDev, timePeriodsSelector } from '../../../selectors/base';

export default class SummaryController {
    static $inject = ['$ngRedux', 'SummaryActions', 'SettingsActions', '$scope', '$q', '$element'];
    constructor($ngRedux, SummaryActions, SettingsActions, $scope, $q, $element) {
        'ngInject';
        this.unsubscribe = $ngRedux.connect(mapStateToThis, { ...SummaryActions, ...SettingsActions })(this);
        this.$scope = $scope;
        this.$q = $q;
        this.$element = $element;
    }

    $onInit() {
        this.loadSummaryBlocks(this.loadOptions, this.blocksToLoad);
        this.cancelListWatch = this.$scope.$watch(() => this.projectsAndGroups, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.loadSummaryBlocks(this.loadOptions, this.blocksToLoad);
            }
        }, true);
        this.cancelWatch = this.$scope.$watch(() => this.settings, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.loadSummaryBlocks(this.loadOptions, this.getNewBlocks(newValue, oldValue));
            }
        }, true);
        this.customDate = { startDate: null, endDate: null };
        this.datePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': () => {
                    const start = this.customDate.startDate.valueOf();
                    const end = this.customDate.endDate.valueOf();
                    const customPeriod = this.timePeriods.find(t => t.custom);
                    return this.loadSummaryBlocks({ ...this.loadOptions, timePeriod: customPeriod, start, end }, this.blocksToLoad);
                }
            }
        }
        this.environmentType = this.environmentTypeSelected(this.environmentType);
    }

    $onDestroy() {
        this.unsubscribe();
        this.cancelWatch();
        this.cancelListWatch();
    }

    get loadOptions() {
        const { timePeriod, environmentType, projectOrGroup } = this;
        let start, end;
        if (timePeriod.custom) {
            start = this.timePeriodInfo.start;
            end = this.timePeriodInfo.end;
        } else {
            end = Date.now();
            start = end - timePeriod.periodInMilliseconds;
        }
        if (environmentType.name.toLowerCase() == "all") {
            environmentType.id = this.environmentTypes.slice(1).map(i => i.id); // TODO id is null we must use envTypeId
        }
        return { timePeriod, environmentType, projectOrGroup, start, end };
    }

    getEnvironmentTypes() {
      return this.environmentTypes.filter(type=> (type.name!=='DryRun'));
    }

    get blocksToLoad() {
        const {
            total,
            successful,
            failed,
            meanTime,
            deploymentDuration,
            failedRatio
        } = this.settings;
        const blocksToLoad = [];
        if (total) {
            blocksToLoad.push('total');
        }
        if (successful) {
            blocksToLoad.push('success');
        }
        if (failed) {
            blocksToLoad.push('failed');
        }
        if (meanTime) {
            blocksToLoad.push('meantime');
        }
        if (deploymentDuration) {
            blocksToLoad.push('deploymentduration');
        }
        if (failedRatio) {
            blocksToLoad.push('failedratio');
        }
        return blocksToLoad;
    }

    getNewBlocks(newSettings, oldSettings) {
        const blocksToLoad = [];
        if (!oldSettings.total && newSettings.total) {
            blocksToLoad.push('total');
        }
        if (!oldSettings.successful && newSettings.successful) {
            blocksToLoad.push('success');
        }
        if (!oldSettings.failed && newSettings.failed) {
            blocksToLoad.push('failed');
        }
        if (!oldSettings.meanTime && newSettings.meanTime) {
            blocksToLoad.push('meantime');
        }
        if (!oldSettings.deploymentDuration && newSettings.deploymentDuration) {
            blocksToLoad.push('deploymentduration');
        }
        if (!oldSettings.failedRatio && newSettings.failedRatio) {
            blocksToLoad.push('failedratio');
        }
        return blocksToLoad;
    }

    onEnvSelected(item) {
        return this.loadSummaryBlocks({ ...this.loadOptions, environmentType: item }, this.blocksToLoad);
    }

    onTimeSelected(item) {
        const timePeriod = item;
        if (!timePeriod.custom) {
            return this.loadSummaryBlocks({ ...this.loadOptions, timePeriod }, this.blocksToLoad);
        } else {
            this.$element.find('#summary-datepicker').click();
        }
    }

    onProjectSelected(item) {
        return this.loadSummaryBlocks({ ...this.loadOptions, projectOrGroup: item }, this.blocksToLoad);
    }

    removeBlock(blockName) {
        const settings = this.globalSettings.main;
        settings[blockName].visible = false;
        if (Object.getOwnPropertyNames(settings).every(p => !settings[p].visible)) {
            settings.visible = false;
        }
        this.saveChanges(this.globalSettings, true);
    }
    environmentTypeSelected(select) {
        if (!select || !this.environmentTypes)
            return;
        const result = this.environmentTypes.filter(envType => envType.id == select.id)
        if (result.length == 0) {
            select = this.environmentTypes[0];
            this.onEnvSelected(select);
        }
        return select.name;
    }
}

function mapStateToThis(state) {
    const obj = {
        projects: projectsForSummerySelector(state),
        projectsAndGroups: projectsAndGroupsMixSelector(state),
        settings: summarySettingsSelector(state),
        data: summarySelector(state),
        gridSize: summaryGridSizeSelector(state),
        timePeriods: timePeriodsSelector(state),
        timePeriod: timePeriodSelector(state),
        environmentTypes: environmentTypesSelectorWithoutDev(state),
        environmentType: environmentTypeSelector(state),
        projectOrGroup: summaryProjectOrGroupSelector(state),
        loading: summaryLoadingSelector(state),
        editMode: editModeSelector(state),
        //viewInfo: viewInfoSelector(state),
        globalSettings: settingsSelector(state),
        timePeriodInfo: timePeriodInfoSelector(state)
    };
    return obj;
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/summary/summary.controller.js